export default __webpack_public_path__ + "static/batch-fcbe4b536bd3cecf5391d415dda7352e.png";